import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// A deep import, not the feature's barrel: the barrel also exports
// PlaygroundScreen, and this file loads eagerly with the route tree, ahead of
// the `.lazy.tsx` chunk that is meant to defer that heavy import
import { SESSION_CHOICES } from '@/features/action-cards-view/playground/session';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute(
  '/_authenticated/playground/action-cards-v2'
)({
  beforeLoad() {
    if (userStore.isInternalUser) return;

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  validateSearch: z.object({
    example: z.string().optional().catch(undefined),
    surface: z.string().optional().catch(undefined),
    state: z.string().optional().catch(undefined),
    session: z.enum(SESSION_CHOICES).optional().catch(undefined),
  }).parse,
});
